<script setup lang="ts">
import {
  getAdaptivePropertiesClassList,
  type AdaptiveProperty,
} from '#shared/lib/breakpoints';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    fluid?: AdaptiveProperty<boolean>;
  }>(),
  { fluid: false }
);

const propertyClasses = computed(() =>
  getAdaptivePropertiesClassList({
    group_fluid: props.fluid,
  })
);
</script>

<template>
  <div :class="['group', propertyClasses]">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
@import '#shared/assets/core.scss';

.group {
  overflow: hidden;

  > :slotted(*) {
    position: relative;
  }

  &_fluid {
    @include adaptive-property {
      &_true {
        background: none;
        border-radius: 0;

        & > :slotted(*:not(:last-child):after) {
          content: '';
          position: absolute;
          height: 1px;
          left: 0;
          right: 0;
          bottom: 0;
          background: #e5e5e5;
        }
      }

      &_false {
        background: var(--app-color-white-secondary);
        border-radius: 0.75rem;

        > :slotted(*:not(:last-child):after) {
          content: '';
          position: absolute;
          height: 1px;
          left: 16px;
          right: 16px;
          bottom: 0;
          background: #e5e5e5;
        }
      }
    }
  }
}
</style>
